import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";
import LocationControl from "@/components/dashboard/LocationControl";
import PinShipmentsCard from "@/components/dashboard/PinShipmentsCard";
import SponsorshipInventoryCard from "@/components/dashboard/SponsorshipInventoryCard";
import PressInquiriesCard from "@/components/dashboard/PressInquiriesCard";
import RsvpCard from "@/components/dashboard/RsvpCard";
import DonationsCard from "@/components/dashboard/DonationsCard";
import CommentsCard from "@/components/dashboard/CommentsCard";
import BucketListAdminCard from "@/components/dashboard/BucketListAdminCard";

export default function DashboardPage() {
  const { user, loading } = useAuth();

  if (loading) return <div className="p-12 text-white/60">Loading...</div>;
  if (!user || user.role !== "admin") return <Navigate to="/login" replace />;

  return (
    <div className="max-w-7xl mx-auto px-6 md:px-8 py-12" data-testid="dashboard-page">
      <div className="overline">Control room</div>
      <h1 className="font-display text-5xl md:text-6xl uppercase mt-3">Creator dashboard</h1>
      <p className="text-white/70 mt-3">Drop a new pin. Update the live route. Keep the Bucket List moving.</p>

      <LocationControl />
      <BucketListAdminCard />
      <PinShipmentsCard />
      <SponsorshipInventoryCard />
      <PressInquiriesCard />
      <RsvpCard />
      <DonationsCard />
      <CommentsCard />
    </div>
  );
}
